var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_2871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 10.7292V14.9526C16.6665 17.2476 11.8423 18.3334 9.1665 18.3334C6.62317 18.3334 1.6665 17.1734 1.6665 14.9526V9.70758L9.1665 13.7601L16.6665 10.7292ZM9.93067 1.66675L-0.833496 6.45841L9.1665 11.8751L18.3332 8.19425V14.1667H19.9998V7.29175L9.93067 1.66675ZM20.8332 18.3334H17.4998C17.9815 17.5001 18.3332 16.2501 18.3332 15.0001H19.9998C19.9998 16.2634 20.3257 17.3826 20.8332 18.3334Z",
    fill: "#7F2144"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_2871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.2d1b9987f1c51f68795007d6c2ed1cb0.svg";
export { ForwardRef as ReactComponent };